import { Gift } from "lucide-react"

import { cn } from "@/lib/utils"

interface OfferFreeGiftProps {
  title: string
  subtitle: string
  image: string
  /** Fill the 94px box exactly (for pre-cropped art) instead of the offset crop. */
  fillImage?: boolean
}

/** "FREE GIFT INCLUDED" green header + a gradient body with the gift preview. */
export function OfferFreeGift({ title, subtitle, image, fillImage }: OfferFreeGiftProps) {
  return (
    <div data-slot="offer-free-gift" className="flex flex-col">
      <div className="flex items-center justify-center gap-1 rounded-t-[12px] bg-green px-2 py-1">
        <Gift className="size-3.5 text-dark-base" strokeWidth={2.5} />
        <span className="text-xs font-bold text-dark-base">FREE GIFT INCLUDED</span>
      </div>
      <div className="flex items-end gap-4 overflow-hidden rounded-b-[8px] bg-gradient-to-r from-purple-light/5 to-purple-light/20 pr-4">
        <div className="relative size-[94px] shrink-0 overflow-hidden">
          <img
            src={image}
            alt=""
            className={cn(
              fillImage
                ? "size-full object-cover"
                : "absolute left-[-12px] top-[12px] size-[106px] max-w-none object-cover",
            )}
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col justify-center gap-0.5 self-stretch py-2">
          <h3 className="font-display text-base font-medium text-purple-light">{title}</h3>
          <p className="text-sm leading-snug text-purple-light/70">{subtitle}</p>
        </div>
      </div>
    </div>
  )
}
